import { getHubApi } from '../general/modules/accountServiceApi/getAccountServiceApi';

export class ServerTime {
    private diff: number|null = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private syncInProgress: Promise<any>;

    public async getTime(): Promise<number> {
        if (this.diff === null && !this.syncInProgress) {
            this.syncInProgress = this.getDiff();
            await this.syncInProgress;
        }

        if (this.syncInProgress) {
            await this.syncInProgress;
        }

        const diff = this.diff ? this.diff : 0;
        return Math.floor(Date.now() / 1000) + diff;
    }

    private async getDiff() {
        const requestStartTs = Math.floor(Date.now() / 1000);
        const hubApi = getHubApi();
        this.syncInProgress = hubApi.getServerTime(window.app.deviceIdentifier);

        const serverTime = await this.syncInProgress
            .then((response) => {
                if (response?.time) {
                    return response.time;
                }

                return null;
            })
            .catch((): null => null);
        this.syncInProgress = void 0;
        if (serverTime !== null) {
            this.diff = serverTime - requestStartTs;
        }
    }
}
